/*

class to generate usersToConferenceRooms map

{
  "state" : "<code>" // active || pending || archive || delete
  "userType" : "<code>" // patient || providerAP || providerLP || orgAdmin || person
  "userId" : "<string>"
  "conferenceRoomId" : "<string>"
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES, WORKSPACE_TYPES, CHANNEL_TYPES, CONFERENCE_ROOM_TYPES } = require('@bcm/constants');
const { MapTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  userState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  conferenceRoomState: Joi.string().valid( ...Object.keys(STATES) ).required(),
  workspaceType: Joi.string().valid( ...Object.keys(WORKSPACE_TYPES) ).required(),
  workspaceId: Joi.string().required(),
  channelType: Joi.string().valid( ...Object.keys(CHANNEL_TYPES) ).required(),
  channelId: Joi.string().required(),
  conferenceRoomType: Joi.string().valid( ...Object.keys(CONFERENCE_ROOM_TYPES) ).required(),
  conferenceRoomId: Joi.string().required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  userName: Joi.string().required(),
  token: Joi.string().required(),
  isOwner: Joi.boolean().required(),
  sessionId: Joi.string().optional(),
};

// Define class
class UsersToConferenceRooms extends MapTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.usersToConferenceRooms.buildPk(obj.userState, obj.userType, obj.userId),
      identifiers.usersToConferenceRooms.buildSk(obj.conferenceRoomState, obj.workspaceType, obj.workspaceId, obj.channelType, obj.channelId, obj.conferenceRoomType, obj.conferenceRoomId),
      identifiers.usersToConferenceRooms.buildGsiPk(obj.conferenceRoomState, obj.workspaceType, obj.workspaceId, obj.channelType, obj.channelId, obj.conferenceRoomType, obj.conferenceRoomId),
      identifiers.usersToConferenceRooms.buildGsiSk(obj.userState, obj.userType, obj.userId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.UsersToConferenceRooms = UsersToConferenceRooms;
exports.usersToConferenceRoomsSchema = schema;